const TOKEN_KEY = "bandjoe_token";

export function getSessionToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function storeSessionToken(token) {
  // Remove tokens written by older builds so a JWT never outlives the tab session.
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.setItem(TOKEN_KEY, token);
}

export function clearSessionToken() {
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
}
